import React from 'react';
import queryString from 'query-string';
import { FormattedMessage } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import Styled from 'styled';

import { ProductsOrderBy } from 'four-nets/bazaar/products/products.graphql.types';

import OrderFilterView from './order-filter-view';
import defaultStyles from './products-filter-bar-view.scss';

export interface Props {
    styles: typeof defaultStyles;
    orderBy: string;
}

class ProductsFilterBarView extends React.Component<Props & RouteComponentProps<any>> {
    changeOrder = (event: React.ChangeEvent<HTMLSelectElement>) => {
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: `?${queryString.stringify({
                ...queryString.parse(this.props.location.search),
                orderBy: event.target.value,
                page: 1,
            })}`,
        });
    };

    render() {
        const { orderBy = ProductsOrderBy.UPDATED } = this.props;
        const styles = this.props.styles!;

        return (
            <div className={styles.filterBar}>
                {this.props.children ? <div className={styles.filters}>{this.props.children}</div> : null}
                <OrderFilterView onChange={this.changeOrder} orderBy={orderBy}>
                    <FormattedMessage id='BAZAAR_ORDER_UPDATED_TITLE' key={ProductsOrderBy.UPDATED}>
                        {message => (
                            <option key={ProductsOrderBy.UPDATED} value={ProductsOrderBy.UPDATED}>
                                {message}
                            </option>
                        )}
                    </FormattedMessage>
                    <FormattedMessage id='BAZAAR_ORDER_CREATED_TITLE_DESC' key={ProductsOrderBy.CREATION_DESC}>
                        {message => (
                            <option key={ProductsOrderBy.CREATION_DESC} value={ProductsOrderBy.CREATION_DESC}>
                                {message}
                            </option>
                        )}
                    </FormattedMessage>
                    <FormattedMessage id='BAZAAR_ORDER_PRICE_TITLE' key={ProductsOrderBy.PRICE}>
                        {message => (
                            <option key={ProductsOrderBy.PRICE} value={ProductsOrderBy.PRICE}>
                                {message}
                            </option>
                        )}
                    </FormattedMessage>
                    <FormattedMessage id='BAZAAR_ORDER_PRICE_DESC_TITLE' key={ProductsOrderBy.PRICE_DESC}>
                        {message => (
                            <option key={ProductsOrderBy.PRICE_DESC} value={ProductsOrderBy.PRICE_DESC}>
                                {message}
                            </option>
                        )}
                    </FormattedMessage>
                </OrderFilterView>
            </div>
        );
    }
}

export default Styled(defaultStyles)(withRouter(ProductsFilterBarView));

